{
  "difficulty": {
    "beginner": "Beginner",
    "intermediate": "Intermediate",
    "advanced": "Advanced"
  },
  "card": {
    "completed": "Completed",
    "courseCount_one": "{{count}} course",
    "courseCount_zero": "{{count}} courses",
    "courseCount_other": "{{count}} courses",
    "progress": "Progress:",
    "courseOf": "Course {{current}} of {{total}}",
    "review": "Review",
    "continue": "Continue",
    "startTrail": "Start path"
  },
  "roadmap": {
    "trailProgress": "Path progress:",
    "coursesCompleted_one": "{{completed}} of {{count}} course completed",
    "coursesCompleted_zero": "{{completed}} of {{count}} courses completed",
    "coursesCompleted_other": "{{completed}} of {{count}} courses completed",
    "required": "Required",
    "courseProgress": "Course progress:",
    "courseNumber": "Course {{number}}",
    "startCourse": "Start course",
    "completedTitle": "🎉 Congratulations! Path completed!",
    "completedDescription": "You've completed every course in this learning path."
  },
  "list": {
    "searchPlaceholder": "Search paths...",
    "difficultyPlaceholder": "Difficulty",
    "tagPlaceholder": "Tag",
    "allTags": "All tags",
    "statusPlaceholder": "Status",
    "sortPlaceholder": "Sort",
    "sort": {
      "title": "Title",
      "difficulty": "Difficulty",
      "duration": "Duration",
      "popularity": "Popularity",
      "progress": "Progress"
    },
    "filter": {
      "all": "All",
      "notStarted": "Not started",
      "inProgress": "In progress",
      "completed": "Completed"
    },
    "resultsCount_one": "{{count}} path found",
    "resultsCount_zero": "{{count}} paths found",
    "resultsCount_other": "{{count}} paths found",
    "activeSearch": "Search: {{value}}",
    "activeDifficulty": "Difficulty: {{value}}",
    "activeTag": "Tag: {{value}}",
    "activeStatus": "Status: {{value}}",
    "clearFilters": "Clear filters",
    "emptyTitle": "No paths found",
    "emptyFiltered": "Try adjusting your search filters.",
    "emptyDescription": "There are no paths available right now."
  }
}
